import { LoginAbstractPageComponent, LoaderSpinnerComponent } from '@aston/foundation/components';
import { Component } from '@angular/core';

@Component({
	template: `<loader-spinner [model]="formLoader" />`,
	imports: [LoaderSpinnerComponent]
})
export class LoginCallbackPageComponent extends LoginAbstractPageComponent {
}
